import { Injectable } from '@angular/core';
import { resetFakeAsyncZone } from '@angular/core/testing';

@Injectable()
export class Globals {
    vTimeZoneIntOffset: any="";
    vTimeZoneOffset :any ="";
    userId: number = 0;
    orgCode: any = "";
    userType: any = "";
    orgId: any = 0;
    userLoginname:any="";
    vTimeZone: any = "";
    vShortTimeZone:any="";
    logType:String="IN";
    /*Added for Modern view shortcut starts*/
    agendaCode = "/ag";
    agendaSubCode = "/sg";
    noteCode = "/nn";
    decisionCode = "/dd";
    taskCode = "/tt";
    dateCode = "/date";
    agDurationCode = "/dur";
    agendaAtLastCode = "/agl";
    agendaSubAtLastCode = "/sgl";
    noteAtLastCode = "/nnl";
    decisionAtLastCode = "/ddl";
    taskAtLastCode = "/ttl";
    preNote = "/pn";
    agDurationRegexCode = /\/dur/g;
    dateRegexCode = /\/date/g;
    agendaRegexCode = /\/ag/g;
    agendaSubRegexCode = /\/sg/g;
    agendaAtLastRegexCode = /\/agl/g;
    agendaSubAtLastRegexCode = /\/sgl/g;
    noteAtLastRegexCode = /\/nnl/g;
    decisionAtLastRegexCode = /\/ddl/g;
    taskAtLastRegexCode = /\/ttl/g;
    noteRegexCode = /\/nn/g;
    decisionRegexCode = /\/dd/g;
    taskRegexCode = /\/tt/g;
    preNoteRegexCode = /\/pn/g;
    preNoteAtLastCode = "/pnl";
    preNoteAtLastRegexCode = /\/pnl/g;
    /*Added for Modern view shortcut ends */

    //rights
    addTaskGlobalRights=true;
    addNoteGlobalRights=true;
    addAgendaGlobalRights=true;
    editAgendaGlobalRights=true;

    //maintanence value
    showTimezone_Date="Y";
    defaultAgendaDuration=10;


    //globalvalues
    //globalAgendaPresenterSource={};
    userRoleList=[];
    globalUserListSource=[];

    //Maintenance Values
    settingValuesList: any=[];

    //Meeting Draft Sended Text
    draftSendedText:any =  "Please edit the MoM before generating draft or approving the MoM, if you want to bring in the edits from the minutes.";
     momApprovedText:any = "Meeting has been Approved"
    //globalvalues
    //globalTaskStatus
    globaltaskStatusList=[];
    //tuleap global variables
    globalProjectList : any = [];
    //globalvalues
    globalMeetingMedium=[];
    globalMeetingType=[];
    globalTimezoneName=[];
    //Global values
    comNoteTypeId=840;
    comNoteTypeCode="IN";
    repotingUsers="";
    roleRightsMap:any;
    roleCode:any;
    globalDocMeetTypeList=[];
    meetingStatus = new Map<string, string>([
        ['1036', 'Yet To Schedule'],
        ['1037', 'Scheduled'],
        ['1038', 'In Progress'],
        ['1039', 'Completed'],
        ['1040', 'Draft Sent'],
        ['1041', 'Approved'],
      ]);
      TaskStatus = new Map<string, string>([
        ['748', 'Completed'],
        ['16', 'Pending']
      ]);
    resetGlobals(){
        this.vTimeZoneIntOffset="";
        this.vTimeZoneOffset="";
        this.userId= 0;
        this.orgCode= "";
        this.userType = "";
        this.orgId = 0;
        this.userLoginname="";
        this.vTimeZone = "";
        this.vShortTimeZone="";
        this.logType="IN";
        /*Added for Modern view shortcut starts*/
        this.agendaCode = "/ag";
        this.noteCode = "/nn";
        this.decisionCode = "/dd";
        this.taskCode = "/tt";
        this.dateCode = "/date";
        this.agDurationCode = "/dur";
        this.agendaAtLastCode = "/agl";
        this.noteAtLastCode = "/nnl";
        this.decisionAtLastCode = "/ddl";
        this.taskAtLastCode = "/ttl";
        this.preNote = "/pn";
        this.agDurationRegexCode = /\/dur/g;
        this.dateRegexCode = /\/date/g;
        this.agendaRegexCode = /\/ag/g;
        this.agendaAtLastRegexCode = /\/agl/g;
        this.noteAtLastRegexCode = /\/nnl/g;
        this.decisionAtLastRegexCode = /\/ddl/g;
        this.taskAtLastRegexCode = /\/ttl/g;
        this.noteRegexCode = /\/nn/g;
        this.decisionRegexCode = /\/dd/g;
        this.taskRegexCode = /\/tt/g;
        this.preNoteRegexCode = /\/pn/g;
        this.preNoteAtLastCode = "/pnl";
        this.preNoteAtLastRegexCode = /\/pnl/g;
        /*Added for Modern view shortcut ends */
    
        //rights
        this.addTaskGlobalRights=true;
        this.addNoteGlobalRights=true;
        this.addAgendaGlobalRights=true;
        this.editAgendaGlobalRights=true;
    
        //maintanence value
        this.showTimezone_Date="Y";
        this.defaultAgendaDuration=10;
    
    
        //globalvalues
        //globalAgendaPresenterSource={};
        this.userRoleList=[];
        this.globalUserListSource=[];
    
        this.settingValuesList=[];
        
        //globalvalues
        //globalTaskStatus
        this.globaltaskStatusList=[];

        //globalProjectList
        this.globalProjectList=[];
        //globalvalues
        this.globalMeetingMedium=[];
        this.globalMeetingType=[];
        this.globalTimezoneName=[];
        //Global values
        this.comNoteTypeId=840;
        this.comNoteTypeCode="IN";
        this.repotingUsers="";
        this.roleRightsMap=null;
        this.globalDocMeetTypeList=[];
    }


}


    
